'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotRadarIcon = function PlotRadarIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M24.5 4.438l-.063-.063h-.063c-2.375-1.75-5.25-2.75-8.375-2.75s-6 1-8.375 2.75h-.063l-.063.063c-3.563 2.625-5.875 6.813-5.875 11.563 0 1.563.25 3 .688 4.438 0 0 .063 0 .063.063a14.302 14.302 0 0 0 13.625 9.875c6.313 0 11.688-4.125 13.625-9.813v-.063c.5-1.438.75-2.938.75-4.5 0-4.75-2.313-8.938-5.875-11.563zM16 4.25c2.125 0 4.063.563 5.813 1.5l-2.125 2.875C18.625 8.062 17.313 7.75 16 7.75a8.291 8.291 0 0 0-3.75.875L10.187 5.75c1.75-.938 3.688-1.5 5.813-1.5zm2.125 11.063l2.125-3c.875 1 1.438 2.25 1.438 3.688 0 .188-.063.313-.063.438zm2.688 3.625c-.813 1.25-2 2.188-3.5 2.563v-3.688zm-6.938-3.625l-3.5 1.125c0-.125-.063-.25-.063-.438 0-1.438.563-2.688 1.375-3.688zM4.25 16c0-3.25 1.313-6.188 3.438-8.313l.375-.375 2.063 2.813c-1.5 1.5-2.375 3.625-2.375 5.875 0 .438.063.875.125 1.25l-3.375 1.125c-.188-.75-.25-1.563-.25-2.375zm10.438 11.688a11.779 11.779 0 0 1-7-3.375c-1-1-1.813-2.188-2.375-3.438l3.375-1.125c1.125 2.313 3.375 3.938 6 4.375v3.563zm0-6.188a5.673 5.673 0 0 1-3.5-2.563l3.5-1.125zm-.875-10.75c.688-.25 1.375-.438 2.188-.438.75 0 1.5.188 2.188.438l-2.188 3zm10.5 13.563c-1.875 1.813-4.313 3.063-7 3.375v-3.563a8.226 8.226 0 0 0 6-4.375l3.375 1.125a11.696 11.696 0 0 1-2.375 3.438zm3.187-5.938l-3.375-1.125c.063-.375.125-.813.125-1.25 0-2.25-.875-4.375-2.375-5.875l2-2.813c.188.125.313.25.438.375A11.715 11.715 0 0 1 27.751 16c0 .813-.063 1.625-.25 2.375z' })
    );
};

exports.default = PlotRadarIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotRadarIcon.js
// module id = 677
// module chunks = 0